






































































import { Component, Vue, Watch } from 'vue-property-decorator'
import axios from 'axios'
import VueJsonPretty from 'vue-json-pretty'
import { WEBOFFICE_API_DOC_URL } from '@/apps/open/constants'
import Button from '@/apps/open/components/Button'
import { ElForm } from 'element-ui/types/form'

enum EPosition {
  QUERY = 'query',
  BODY = 'body'
}

interface IApiParam {
  name: string,
  required: boolean,
  position: EPosition,
  formatter?: Function
}

interface IApi {
  name?: string,
  method?: string
  type: string,
  url: string,
  params: IApiParam[]
}

const API_TYPE_LIST = [
  {
    label: '金山文档在线编辑',
    value: 'weboffice'
  }
]

const API_LIST: IApi[] = [
  {
    name: '获取用户信息',
    type: 'weboffice',
    url: '/v1/3rd/user/info',
    method: 'POST',
    params: [
      { name: 'access_token', required: true, position: EPosition.QUERY },
      { name: 'file-id', required: true, position: EPosition.QUERY },
      { name: '_w_signature', required: true, position: EPosition.QUERY },
      { name: '_w_appid', required: true, position: EPosition.QUERY },
      { name: 'ids', required: true, position: EPosition.BODY, formatter: (values: string) => values.split(',') },
      { name: 'param', required: false, position: EPosition.QUERY }
    ]
  },
  {
    name: '通知此文件目前有哪些人正在协作',
    type: 'weboffice',
    url: '/v1/3rd/file/online',
    method: 'POST',
    params: [
      { name: 'access_token', required: true, position: EPosition.QUERY },
      { name: 'file-id', required: true, position: EPosition.QUERY },
      { name: '_w_signature', required: true, position: EPosition.QUERY },
      { name: '_w_appid', required: true, position: EPosition.QUERY },
      { name: 'ids', required: true, position: EPosition.BODY },
      { name: 'param', required: false, position: EPosition.QUERY }
    ]
  },
  {
    name: '获取特定版本的文件信息',
    type: 'weboffice',
    url: '/v1/3rd/file/version',
    method: 'GET',
    params: [
      { name: 'access_token', required: true, position: EPosition.QUERY },
      { name: 'file-id', required: true, position: EPosition.QUERY },
      { name: '_w_signature', required: true, position: EPosition.QUERY },
      { name: '_w_appid', required: true, position: EPosition.QUERY },
      { name: 'verison', required: true, position: EPosition.QUERY },
      { name: 'param', required: false, position: EPosition.QUERY }
    ]
  },
  {
    name: '文件重命名',
    type: 'weboffice',
    url: '/v1/3rd/file/rename',
    method: 'PUT',
    params: [
      { name: 'access_token', required: true, position: EPosition.QUERY },
      { name: 'file-id', required: true, position: EPosition.QUERY },
      { name: '_w_signature', required: true, position: EPosition.QUERY },
      { name: '_w_appid', required: true, position: EPosition.QUERY },
      { name: 'name', required: true, position: EPosition.QUERY },
      { name: 'param', required: false, position: EPosition.QUERY }
    ]
  },
  {
    name: '获取所有历史版本文件信息',
    type: 'weboffice',
    url: '/v1/3rd/file/history',
    method: 'POST',
    params: [
      { name: 'access_token', required: true, position: EPosition.QUERY },
      { name: 'file-id', required: true, position: EPosition.QUERY },
      { name: '_w_signature', required: true, position: EPosition.QUERY },
      { name: '_w_appid', required: true, position: EPosition.QUERY },
      { name: 'offset', required: true, position: EPosition.QUERY },
      { name: 'count', required: true, position: EPosition.QUERY },
      { name: 'param', required: false, position: EPosition.QUERY }
    ]
  }
]

@Component({
  components: {
    Button,
    VueJsonPretty
  },
  data: () => ({
    WEBOFFICE_API_DOC_URL,
    API_TYPE_LIST
  })
})
export default class ApiTool extends Vue {
  app_id = ''
  apiType = 'weboffice'
  apiUrl = ''
  form = {} as any
  result = {} as any

  $refs!: {
    form: ElForm
  }

  get apiList () {
    return API_LIST.filter((item: any) => item.type === this.apiType)
  }

  get apiParams () {
    const list = this.apiList || []
    const api = list.find((item) => item.url === this.apiUrl)
    return api ? api.params : []
  }

  @Watch('apiType')
  onApiTypeChange () {
    if (this.apiType === 'signature') {
      const api = API_LIST.find((item) => item.type === 'signature')
      this.apiUrl = api ? api.url : ''
    } else {
      this.apiUrl = ''
    }
  }

  @Watch('apiUrl')
  onApiUrlChange () {
    this.form = {
      _w_appid: this.app_id
    }
    this.$nextTick(() => {
      this.$refs.form.clearValidate()
    })
  }

  async created () {
    this.app_id = this.$route.params['id']
  }

  async submit () {
    let res = {} as any
    const api = this.apiList.find((item) => item.url === this.apiUrl) || {} as any
    await this.$refs.form.validate()
    try {
      const params = {} as any
      const data = {} as any

      this.apiParams.forEach((item) => {
        let value = this.form[item.name]
        value = value ? value.trim() : ''

        if (item.formatter) {
          value = item.formatter(value)
        }

        if (item.position === 'query') {
          params[item.name] = value
        }

        if (item.position === 'body') {
          data[item.name] = value
        }
      })

      res = await axios({ url: this.apiUrl, method: api.method, params, data })
    } catch (error) {
      res = error.response
    }
    this.result = {
      ...res,
      api
    }
  }
}
